var map = {
	"./role_select_high.jpg": "./src/assets/images/role_select/role_select_high.jpg",
	"./role_select_primary.jpg": "./src/assets/images/role_select/role_select_primary.jpg",
	"./role_select_secondary.png": "./src/assets/images/role_select/role_select_secondary.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/role_select sync recursive ^\\.\\/.*$";